<app-menu-template3>
  <main class="container-fluid">
    <article class="row bg-white shadow mb-3 mt-3 ml-0 mr-0 ">
      <section class="col-3 border-right p-4 mt-5 mb-5" *ngIf="authService.getTipoUser() === tipo_prestador">
        <header class="text-center mb-3">
          <label class="h5">Agregar Arrendatario</label>
        </header>
        <form [formGroup]="formArrendamiento" (ngSubmit)="onOperarArrendatario()">
          <div class="form-group">
            <label class="small text-secondary" for="nit">NIT</label>
            <input id="nit" formControlName="nit" type="text" class="form-control form-control-sm" (change)="onValidarPrestador()">
          </div>
          <div class="form-group">
            <label class="small text-secondary" for="digito_verificacion">Digito Verificación</label>
            <input id="digito_verificacion" formControlName="digito_verificacion" type="text" class="form-control form-control-sm"
              (change)="onValidarPrestador()">
          </div>
          <div class="form-group">
            <label class="small text-secondary" class="small text-secondary" for="correo_electronico">Correo
              Electronico</label>
            <input id="correo_electronico" formControlName="correo_electronico" type="text" class="form-control form-control-sm">
          </div>
          <div class="form-group">
            <label class="small text-secondary" for="razon_social">Razon social</label>
            <input id="razon_social" formControlName="razon_social" type="text" class="form-control form-control-sm">
          </div>
          <div class="form-group">
            <label class="small text-secondary" for="telefono_reportado">Numero Telefonico</label>
            <input id="telefono_reportado" formControlName="telefono_reportado" type="text" class="form-control form-control-sm">
          </div>
          <div class="form-group">
            <label class="small text-secondary" for="fecha_inicio_arrendamiento">Fecha Inicio Arrendamiento</label>
            <div class="input-group">
              <input id="fecha_inicio_arrendamiento" class="form-control form-control-sm" formControlName="fecha_inicio_arrendamiento"
                placeholder="yyyy/mm/dd" ngbDatepicker #inicio="ngbDatepicker" (dateSelect)="onMinFechaFin($event)">
              <div class="input-group-append">
                <button class="btn btn-outline-secondary calendar" (click)="inicio.toggle()" type="button"></button>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="small text-secondary" for="fecha_fin_arrendamiento">Fecha Fin Arrendamiento</label>
            <div class="input-group">
              <input id="fecha_fin_arrendamiento" class="form-control form-control-sm" formControlName="fecha_fin_arrendamiento"
                placeholder="yyyy/mm/dd" ngbDatepicker #fin="ngbDatepicker" [minDate]="fecha_inicio">
              <div class="input-group-append">
                <button class="btn btn-outline-secondary calendar" (click)="fin.toggle()" type="button"></button>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="small text-secondary" for="activo">Estado</label>
            <select class="form-control form-control-sm" id="activo" formControlName="activo" [attr.disabled]="!selectArrendatario ? '' : null">
              <!-- <option class="" [ngValue]="null" [selected]="true">
                Seleccione
              </option> -->
              <option class="" [ngValue]="true" [selected]="false">
                Activo
              </option>
              <option class="" [ngValue]="false" [selected]="false">
                Inactivo
              </option>
            </select>
          </div>
          <div class="form-row mt-5">
            <button class="btn btn-primary m-auto solicitud-btn-principal" type="submit" [disabled]="!formArrendamiento.valid">{{!selectArrendatario
              ? 'Agregar' : 'Editar'}}</button>
          </div>
        </form>
      </section>
      <section class="col p-4 mt-5 mb-5" *ngIf="dataTabla.paging.totalItems >= 1; else no_data">
        <app-ayudas [ayuda]="ayudaService.arredatario"></app-ayudas>
        <img src="../../../../../assets/icons/solicitud.png" class="d-inline-block img-responsive mr-3" alt="">
        <label class="h5">Listado de arrendatarios</label>
        <div class="table-responsive">
          <app-tablas [page] = "paginaActual" [headers]="headersArrendatario" [sizeData]="dataTabla.paging.totalItems" (paginado)="onPaginado($event)"
            class="table-responsive">
            <tr *ngFor="let item of dataTabla.items; let i=index" class="small">
              <td>{{item.razon_social}}</td>
              <td>{{item.correo_electronico}}</td>
              <td>{{item.numero_telefonico}}</td>
              <td>{{item.nit}}</td>
              <td>{{item.digito_verificacion}}</td>
              <td>{{item.fecha_inicio_arrendamiento | date:'d/MMM/yyyy'}}</td>
              <td>{{item.fecha_fin_arrendamiento | date:'d/MMM/yyyy'}}</td>
              <td>{{item.activo ? 'Activo' : 'Inactivo'}}</td>
              <td>
                <img src="../../../../../../../assets/icons/edit.png" class="pointer" alt="" height="25" (click)="onCargarEditarArrendatario(item)">
                <img src="../../../../../../../assets/icons/delete.png" class="pointer" alt="" height="25" (click)="onEliminarArrendatario(item)">
              </td>
            </tr>
          </app-tablas>
        </div>
      </section>
      <ng-template #no_data>
        <section class="col p-4 mt-5 mb-5">
          <header class="col-12">
            <app-ayudas [ayuda]="ayudaService.arredatario"></app-ayudas>
            <figure class="figure w-100 text-center">
              <img class="img-fluid mb-4" src="../../../../../../../assets/images/sin_establecimiento.png" />
              <figcaption>
                <label class="h3">Aún no tienes arrendatarios</label>
              </figcaption>
            </figure>
          </header>
        </section>
      </ng-template>
    </article>
  </main>
</app-menu-template3>